import moment from 'moment';
import React, { Component } from 'react';
import { OverrideBool } from '../../utilities/utils';
import Footer from '../SubComponents/Footer/Footer';
import Header from '../SubComponents/Header/Header';
import ItemSelection from '../SubComponents/ItemSelection/ItemSelection';
import Modal, { DefaultModalParams } from '../SubComponents/Modal/Modal';
import PriceBar from '../SubComponents/PriceBar/PriceBarContainer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { ProgressStep } from '../SubComponents/ProgressIndicator/ProgressIndicator';
// import ProgressIndicator from '../SubComponents/ProgressIndicator/ProgressIndicatorContainer';
import './StationSelection.css';
import { notify, stopNotify } from '../../selectors/sequence';
// import { display } from '@material-ui/system';
import { addCustomTagEvent } from '../../utilities/customTag';

// Props
// landscape: boolean;

export default class StationSelection extends Component {
  // autoInterval: number;
  // carouselRef: HTMLElement | null;
  // timeslotsRef: HTMLElement | null;
  // inputFrozen: boolean;

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      modalParams: DefaultModalParams,
      notify: true,

      unMovableTimeSlots: [],
      nonRefundableTimeSlots: [],
      restrictedTimesExist: false,

      restrictionsModalOpen: false,
      restrictionsModalParams: DefaultModalParams,
    };
    this.inputFrozen = false;

  }

  componentDidMount() {
    this.inputFrozen = false;
    notify(this.props.popups);

    //check whether to populate local state or not with store data
    if (this.props.restrictedTimeSlots.restrictedTimesExist !== undefined) {
      this.setState({
        unMovableTimeSlots: this.props.restrictedTimeSlots.unMovableTimeSlots,
        nonRefundableTimeSlots: this.props.restrictedTimeSlots.nonRefundableTimeSlots,
        restrictedTimesExist: this.props.restrictedTimeSlots.restrictedTimesExist
      });
    }
  }

  componentWillUnmount() {
    stopNotify();
  }

  tranForward = () => {
    if (!this.inputFrozen) {
      addCustomTagEvent({
          event: 'StationNextEvent',
          category: 'Cart',
          label: 'VR Station'
      });

      this.inputFrozen = true;
      this.props.transitionForward()
        .then(() => { this.inputFrozen = false; })
        .catch((error) => {
          console.error(error);
          this.inputFrozen = false;
          this.openModal({
            title: this.props.languageObj.trans_forward.title,
            content: this.props.languageObj.trans_forward.content,
            acceptText: this.props.languageObj.trans_forward.accept,
            cancelText: '',
            isConfirm: false,
            onAccept: () => { this.props.resetApp(); },
            onCancel: () => { /**/ }
          });
        });
    }
  }

  //need to add intermediate step for bookings that notifies them if bookings are unmovable and/or non-refundable...
  onClickNext = () => {
    if (!this.inputFrozen && Object.keys(this.props.selectedStations).length > 1) {
      this.openModal({
        title: this.props.languageObj.click_next.title,
        content: this.props.languageObj.click_next.content,
        acceptText: this.props.languageObj.click_next.accept,
        cancelText: this.props.languageObj.click_next.cancel,
        isConfirm: true,
        onAccept: () => { this.warnOfRestrictions(); },
        // onAccept: () => { this.tranForward() },
        onCancel: () => { /**/ }
      });
    }
    else if (!this.inputFrozen) this.warnOfRestrictions();
  }

  warnOfRestrictions = () => {
    //if no restricted times exist, then continue
    if (!this.state.restrictedTimesExist) {
      this.tranForward();
    } else {

      if(this.props.isExtraLife) {

        this.openRestrictionsModal({
          title: this.props.languageObj.extra_life_restrictions.title,
          content: this.props.languageObj.extra_life_restrictions.content,
          unMovableLabel: this.props.languageObj.extra_life_restrictions.unmovable_label,
          nonRefundableLabel: this.props.languageObj.extra_life_restrictions.no_refund_label,
          acceptText: this.props.languageObj.extra_life_restrictions.accept,
          cancelText: this.props.languageObj.extra_life_restrictions.decline,
          isConfirm: true,
          onAccept: () => {
            this.tranForward();
          },
          onCancel: () => { /**/ }
        })
      } else {
        this.openRestrictionsModal({
          title: this.props.languageObj.restrictions.title,
          content: this.props.languageObj.restrictions.content,
          unMovableLabel: this.props.languageObj.restrictions.unmovable_label,
          nonRefundableLabel: this.props.languageObj.restrictions.no_refund_label,
          acceptText: this.props.languageObj.restrictions.accept,
          cancelText: this.props.languageObj.restrictions.decline,
          isConfirm: true,
          onAccept: () => {
            this.tranForward();
          },
          onCancel: () => { /**/ }
        })
      }

    }
  }

  onClickPrev = () => {
    if (this.props.isExtraLife) {
      if (!this.inputFrozen) {
        addCustomTagEvent({
            event: 'StationBackEvent',
            category: 'Cart',
            label: 'VR Station'
        });
        this.props.transitionToDate().catch((error) => {
          console.error('Failed to go back from station selection: ' + error);
        });
      }
    } else {
      if (!this.inputFrozen) {
        addCustomTagEvent({
            event: 'StationBackEvent',
            category: 'Cart',
            label: 'VR Station'
        });
        this.props.transitionBack().catch((error) => {
          console.error('Failed to go back from station selection: ' + error);
        });
      }
    }
  }

  //check if non-refundable and/or unmovable here
  updateItemQuantity = (timeslotId, itemId, quantity) => {
    this.props.selectStation(timeslotId, itemId, quantity);
    this.checkTimeSlotRestrictions(timeslotId, itemId, quantity);
  }

  checkTimeSlotRestrictions = (timeslotId, itemId, quantity) => {
    //check if item exists in UNMOVABLE TIMES ARRAY
    let unMovableTimes = this.state.unMovableTimeSlots;
    let exists = unMovableTimes.some(timeslot => Number(timeslot.slotId) === Number(timeslotId));
    if (exists) {
      //check if the quantity is 0
      //if quantity is 0, then remove this timeslotId from the array
      if (quantity === 0) {
        for (let i = 0; i < unMovableTimes.length; i++) {
          if (unMovableTimes[i].slotId === timeslotId) {
            unMovableTimes.splice(i, 1);
            i--;
          }
        }
      }
      //else: do nothing - we want to keep any restricted timeslotIds in here
    } else {
      //item does not exist in array; we process it to see if it is unmovable
      if (!this.props.generalizedItems.items[itemId].is_movable) {
        //add item in
        let time = this.props.generalizedItems.timeslots[String(timeslotId)].moment;
        let displayTime = moment(time).format("h") + ":" + moment(time).format("mm") + " " + moment(time).format("a");
        unMovableTimes.push({ slotId: timeslotId, time: displayTime });
      }
      //else: do nothing, we don't want to include movable times in this array
    }

    //check if item exists in NON_REFUNDABLE ARRAY
    let nonRefundTimes = this.state.nonRefundableTimeSlots;
    exists = nonRefundTimes.some(timeslot => Number(timeslot.slotId) === Number(timeslotId));
    if (exists) {
      //check if the quantity is 0
      //if quantity is 0, then remove this timeslotId from the array
      if (quantity === 0) {
        for (let i = 0; i < nonRefundTimes.length; i++) {
          if (nonRefundTimes[i].slotId === timeslotId) {
            nonRefundTimes.splice(i, 1);
            i--;
          }
        }
      }
      //else: do nothing - we want to keep any restricted timeslotIds in here
    } else {
      //item does not exist in array; we process it to see if it is non-refundable
      if (!this.props.generalizedItems.items[itemId].is_refundable) {
        //add item in
        let time = this.props.generalizedItems.timeslots[String(timeslotId)].moment;
        let displayTime = moment(time).format("h") + ":" + moment(time).format("mm") + " " + moment(time).format("a");
        nonRefundTimes.push({ slotId: timeslotId, time: displayTime });
      }
      //else: do nothing, we don't want to include refundable times in this array
    }

    //check if either array contains any items
    let numRestrictedTimes = unMovableTimes.length + nonRefundTimes.length;
    let restrictedTimesPresent = (numRestrictedTimes > 0) ? true : false;

    //set states
    this.setState({
      unMovableTimeSlots: unMovableTimes,
      nonRefundableTimeSlots: nonRefundTimes,
      restrictedTimesExist: restrictedTimesPresent
    });

    let stateObject = {
      unMovableTimeSlots: unMovableTimes,
      nonRefundableTimeSlots: nonRefundTimes,
      restrictedTimesExist: restrictedTimesPresent
    }

    this.props.updateRestrictedStations(stateObject);
  }

  updateItemSubQuantity = (timeslotId, itemId, quantity) => {
    this.props.selectExtra(timeslotId, itemId, quantity);
  }

  validateItemQuantity = (timeslotId, itemId, quantity) => {
    return OverrideBool.None;
  }

  onCloseModal = () => {
    this.setState({
      modalOpen: false
    });
  }

  openModal = (params) => {
    this.setState({
      modalOpen: true,
      modalParams: params
    });
  }

  onCloseRestrictionModal = () => {
    this.setState({
      restrictionsModalOpen: false
    });
  }

  openRestrictionsModal = (params) => {
    this.setState({
      restrictionsModalOpen: true,
      restrictionsModalParams: params
    });
  }

  render() {

    // let restrictions = {
    //   unMovableTimeSlots: this.state.unMovableTimeSlots,
    //   nonRefundableTimeSlots: this.state.nonRefundableTimeSlots,
    //   restrictedTimesExist: this.state.restrictedTimesExist
    // }
    return (
      <div className={'AppContainer'}>
        <Header
          header={this.props.locationName.toLocaleUpperCase()}
          subHeader={moment(this.props.selectedDate).format('dddd, MMMM Do').toLocaleUpperCase()}
          hideOnMobile={true}
        />
        {/* <ProgressIndicator currentStep={ProgressStep.Station} /> */}
        <div className={'StationSelection'}>
          <ItemSelection
            landscape={this.props.landscape}
            timeslots={this.props.generalizedItems.timeslots}
            items={this.props.generalizedItems.items}
            selectedItems={this.props.selectedStations}
            selectedExtra={this.props.selectedExtras}
            updateItemQuantity={this.updateItemQuantity}
            updateSubQuantity={this.updateItemSubQuantity}
            validateQuantity={this.validateItemQuantity}
            itemCategoryId={1} // Replace with not hard-coded after spine replacement
            isToggle={false}
            isLocalQuantity={false}
          />
        </div>
        {/* Multiple timeslots notice modal */}
        <Modal
          isOpen={this.state.modalOpen}
          handleClose={this.onCloseModal}
          modalType={0}
          {...this.state.modalParams}
        />
        {/* Restricted timeslots notice modal */}
        <Modal
          isOpen={this.state.restrictionsModalOpen}
          handleClose={this.onCloseRestrictionModal}
          modalType={1}
          {...this.state.restrictionsModalParams}
        />
        <ToastContainer
          className={'ToastContainer'}
          toastClassName={'Toast'}
          progressClassName={'ToastProgress'}
          position={'top-right'}
          newestOnTop={true}
          rtl={false}
        />
        <PriceBar isSubtotal={true} />
        <Footer
          nextName={this.props.languageObj.render.next_name}
          prevName={this.props.languageObj.render.prev_name}
          nextDisabled={this.props.totalStations === 0}
          prevDisabled={false}
          handleClickNext={this.onClickNext}
          handleClickPrev={this.onClickPrev}
        />
      </div>
    );
  }
}
